import React, { useState, useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Purpose from './components/Purpose';
import Services from './components/Services';
import Product from './components/Product';
import Testimonials from './components/Testimonials';
import CTABanner from './components/CTABanner';
import Contact from './components/Contact';
import Footer from './components/Footer';
import './App.css';

function App() {
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [isChatAvailable, setIsChatAvailable] = useState(false);
  const chatWidgetUrl = 'https://api.zwiftlabs.com/static/widget.html';

  useEffect(() => {
    // Check if the chat widget URL is accessible
    const checkChatAvailability = async () => {
      try {
        const response = await fetch(chatWidgetUrl, { method: 'HEAD' });
        if (response.ok) {
          setIsChatAvailable(true);
        }
      } catch (error) {
        console.log('Chat widget not available');
        setIsChatAvailable(false);
      }
    };

    checkChatAvailability();
  }, []);

  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <Testimonials />
        <Services />
        <Purpose />
        <Product />
        <CTABanner />
        <Contact />
      </main>
      <Footer />
      
      {/* Chat Widget - Bottom Right - Only show if chat is available */}
      {isChatAvailable && (
        <div className="fixed bottom-20 right-6 z-50 flex flex-col items-end">
          {/* Chat Window */}
          {isChatOpen && (
            <div className="mb-1 animate-slide-up">
              <iframe
                src={chatWidgetUrl}
                title="Zwift Labs Assistant"
                style={{
                  width: '400px',
                  height: '650px',
                  border: '1px solid #e5e7eb',
                  borderRadius: '10px',
                  boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1)'
                }}
                allow="clipboard-read; clipboard-write"
              />
            </div>
          )}
          
          {/* Chat Bubble Button */}
          <button
            onClick={() => setIsChatOpen(!isChatOpen)}
            className="bg-black hover:bg-neutral-800 text-white rounded-full w-14 h-14 flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-300"
            aria-label={isChatOpen ? "Close chat" : "Open chat"}
          >
            {isChatOpen ? (
              // Close icon (X)
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            ) : (
              // Chat icon
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-7 w-7"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
                />
              </svg>
            )}
          </button>
        </div>
      )}
    </div>
  );
}

export default App;
